module.exports = __webpack_public_path__ + "media/images/athletes/2411-9b7eafca269df8885bb4bf6a9b46a46f.png";